import { useContent } from "../content/ContentContext";
import { SectionLabel } from "../components/Ui";
import { Reveal } from "../components/Reveal";
import LinkedInLink from "../components/LinkedInLink";

export default function AboutSection() {
  const { content } = useContent();
  const { site } = content;
  const portrait = site.aboutPortrait;
  return (
    <section id="about" data-testid="section-about" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-12 sm:px-6 lg:px-8 lg:py-20">
      <Reveal>
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <SectionLabel>About</SectionLabel>
            <p className="mt-6 text-lg font-bold leading-relaxed text-ink" data-testid="about-intro-lead">
              {site.aboutIntro[0].split(/(understand)/i).map((part, i) =>
                /^understand$/i.test(part) ? <em key={i} className="italic">{part}</em> : part
              )}
            </p>
            <p className="mt-5 leading-relaxed text-muted">{site.aboutIntro[1]}</p>
            <div className="mt-5">
              <LinkedInLink href={site.linkedin} variant="underline" testid="about-linkedin-link">
                View my LinkedIn profile →
              </LinkedInLink>
            </div>
          </div>
          <div className="lg:col-span-5">
            <figure data-testid="about-photo-card" className="overflow-hidden rounded-2xl border border-line bg-white">
              <img
                src={portrait.src}
                alt={portrait.alt}
                data-testid="about-photo-img"
                className="h-[460px] w-full object-cover object-top"
              />
              <figcaption className="border-t border-line px-6 py-4 text-center">
                <span className="block font-serif text-lg font-semibold text-ink">{portrait.caption}</span>
                <span className="mt-0.5 block font-mono text-[10px] uppercase tracking-[0.18em] text-accent">
                  {portrait.captionSub}
                </span>
                <span className="mt-2 block text-xs text-muted" data-testid="about-location-line">
                  Location: France. Working with clients worldwide
                </span>
                <div className="mt-1.5 flex justify-center">
                  <LinkedInLink href={site.linkedin} variant="pill" testid="profile-linkedin-link">
                    Connect on LinkedIn →
                  </LinkedInLink>
                </div>
              </figcaption>
            </figure>
          </div>
        </div>
      </Reveal>

    </section>
  );
}
